import { createContext } from "react";

export const ExpenseContext = createContext();
